import React, { Component } from "react";
import { FiChevronDown } from "react-icons/fi";
import { terms } from "./services";
import ImageProvider from "../../../base/features/blocks/ImageProvider";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import FactorDetail from "./blocks/FactorDetail";
import SimpleHeader from "../../../base/features/blocks/SimpleHeader";
import Image from "../../../base/features/micro/Image";
import CardNumberDetail from "./blocks/CardNumberDetail";
import { cartInvoicePay } from "../blocks/services";
import { Redirect } from "react-router-dom";
import { fixObject } from "../../../base/utils/convert_to_object";
import FactorDetail2 from "./blocks/FactorDetail2";
import { apiService } from "../../../base/utils/service";
import { getInvoiceCartUid, getShopUid } from "../../../settings/domainManager";

class Factor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      card: null,
      payable_price: null,
      images: [],
      shipping: null,
      price: null,
      discount: null,
      shop: null,
      terms: [],
      termsModal: false,
      factorDetail: false,
      cardDetail: false,
      shop_uid: getShopUid(),
      cart_uid: getInvoiceCartUid(),
      invoiceUid: "",
      payment: window.location.search
        ? fixObject(window.location.search).payment
        : "",
      selectedGateway: "",
    };
  }
  componentDidMount() {
    this.getInvoiceDetails();
  }
  getInvoiceDetails() {
    apiService(
      `v1/shops/${this.state.shop_uid}/cart/${this.state.cart_uid}/invoice`
    ).then((items) => {
      items &&
        this.setState({
          card: items.payments.card,
          payments: items.payments,
          payable_price: items.payable_price,
          discount: items.discount,
          price: items.price,
          shipping: items.shipping,
          invoiceUid: items.uid,
          shop: items.shop,
        });
    });
  }
  // openApp(package_name){
  //   if (isAndroid) {
  //     const url =
  //       `intent://asanpardakht.com/#Intent;scheme=https;package=${package_name};end`;
  //     window.location.replace(url);
  //   } else if (isIOS) {
  //     window.location.replace("instagram://");

  //     setTimeout(() => {
  //       window.location.replace(
  //         "https://apps.apple.com/us/app/instagram/id389801252"
  //       );
  //     }, 10000);
  //   } else {
  //     window.location.replace("https://instagram.com");
  //   }
  // }

  getTerms(path) {
    terms(path).then((items) => {
      items && this.setState({ terms: items });
    });
  }
  payInvoice() {
    this.setState({ pending: true });
    const formData = new FormData();
    if (this.state.images.length > 0) {
      formData.append("image", this.state.images[0].file);
    }
    cartInvoicePay(this.state.shop_uid, this.state.invoiceUid, formData).then(
      (items) => {
        items &&
          this.setState({ orderUid: items.uid }, () =>
            this.setState({ redirect: true, pending: false })
          );
      }
    );
  }
  paySpot() {
    this.setState({ pending: true });
    apiService(
      `v1/shops/${this.state.shop_uid}/cart/${this.state.invoiceUid}/invoice/pay/on-spot`,
      "put"
    ).then((items) => {
      items &&
        this.setState({ orderUid: items.uid }, () =>
          this.setState({ redirect: true, pending: false })
        );
    });
  }
  payGateway() {
    this.setState({ pending: true });
    let params = {
      gateway: this.state.selectedGateway,
    };
    apiService(
      `v1/shops/${this.state.shop_uid}/cart/${this.state.invoiceUid}/invoice/pay/online`,
      "post",
      params,
      true
    ).then((data) => {
      if (data && data.url) {
        window.location.href = data.url;
      }
      if (
        data.response &&
        data.response.status &&
        data.response.status === 400 &&
        data.response.data.errors.gateway
      ) {
        Swal.fire({
          text: data.response.data.errors.gateway[0].message,
          showConfirmButton: false,
          toast: true,
          customClass: {
            htmlContainer: "text-center m-0",
          },
          timer: 3000,
          timerProgressBar: true,
        });
      }
      this.setState({ pending: false });
    });
  }
  render() {
    return (
      <div className="container-fluid px-0" dir="rtl">
        {this.state.redirect && (
          <Redirect push to={`/orders/${this.state.orderUid}`} />
        )}
        <SimpleHeader text="تکمیل سفارش" />
        <body style={{ marginTop: "80px", marginBottom: "80px" }}>
          {this.state.payments &&
            this.state.payment === "gateway" &&
            this.state.payments.gateways.map((gateway, g) => (
              <div
                className="row mx-4 mt-3 rounded14 border p-3"
                onClick={() => this.setState({ selectedGateway: gateway.uid })}
              >
                <div className="col-2 px-0 text-center align-self-center">
                  <input
                    class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                    type="radio"
                    name="paymentRadio"
                    checked={this.state.selectedGateway === gateway.uid}
                    value={gateway.uid}
                  />
                </div>
                <div className="col px-0">
                  <p className="fw-bold mb-1">{gateway.title}</p>
                </div>
                <div className="col-auto px-0">
                  <Image
                    imageUri={gateway.cover && gateway.cover.thumbnail}
                    imageHeight={"30"}
                    imageWidth={"30"}
                    imgClassName={""}
                    extraClassName={"rounded7 p-1 bg-color-main"}
                  />
                </div>
              </div>
            ))}
          {this.state.payable_price &&
            this.state.card &&
            this.state.payment === "card" && (
              <div className="row mx-0 px-4 mt-3">
                <div className="col-12 px-2 fw-bolder fs-6 align-self-center">
                  <p className="">ارسال فیش واریز وجه</p>
                  <p className="mb-0 fs-7 text-muted">
                    توجه داشته باشید تا زمانی که فیش واریز را بارگذاری نکنید
                    سفارش شما ثبت نخواهد شد
                  </p>
                </div>

                <div className="col-12 mt-3 px-0 text-center">
                  <div className="rounded14 border p-3 shadow-sm mb-2">
                    <div className="row mx-0 px-0 mb-3">
                      <span className="col px-0 fs-6 fw-bold text-end">
                        مبلغ قابل پرداخت
                      </span>
                      <span
                        className="col-auto px-0 fs-6 fw-bolder"
                        onClick={() => this.setState({ factorDetail: true })}
                      >
                        {this.state.payable_price.title}
                        <span className="me-1 fs-7">
                          {this.state.payable_price.currency}
                          <FiChevronDown className="" size={18} />
                        </span>
                      </span>
                    </div>

                    <div className="row mx-0 px-0 mb-3">
                      <span className="col px-0 fs-6 fw-bold text-end">
                        شماره کارت
                      </span>
                      <span
                        className="col-auto px-0 fs-6 fw-bold color-second"
                        onClick={() => this.setState({ cardDetail: true })}
                      >
                        <span dir="ltr">{this.state.card.number}</span>
                        <FiChevronDown className="me-1" size={18} />
                      </span>
                    </div>
                    <div className="row mx-0 px-0">
                      <span className="col px-0 fs-6 fw-bold text-end">
                        به نام
                      </span>
                      <span className="col-auto px-0 fs-6 fw-bold">
                        {this.state.card.name}
                      </span>
                    </div>
                  </div>
                  <span className="fs-7 fw-bolder text-muted">
                    آقا/خانم{" "}
                    <span className="color-main btn p-0 fs-7 fw-bolder">
                      {this.state.card.name}
                    </span>{" "}
                    {this.state.shop && (
                      <span>
                        مدیر فروشگاه{" "}
                        <span className="color-main btn p-0 fs-7 fw-bolder">
                          {this.state.shop.title}
                        </span>{" "}
                      </span>
                    )}
                    است
                  </span>
                </div>
              </div>
            )}
          {/* <div className="row mx-0 px-4 mt-3">
            <div className="col px-0 fw-bolder fs-6 align-self-center">
              انتخاب روش پرداخت
            </div>
            <div className="col-12 p-3 my-3 bg-light-gray fs-7 fw-bolder rounded14">
              <p className="mb-0">
                برای پرداخت هزینه محصول به روش کارت به کارت لطفا یکی از گزینه
                های زیر را انتخاب کنید
              </p>
            </div>
            {this.state.card &&
              this.state.card.payment_apps &&
              this.state.card.payment_apps.map((app, a) => (
                <div className="col-6 p-2">
                  <OpenApp
                    href="https://mycoolappwebsite.com"
                    android={`intent://scan/#Intent;scheme=${app.name};package=${app.package};end`}
                    ios="whatever deep link you need on iOS"
                  >
                    <div className="rounded14 border p-3">
                      <img src={app.icon.icon_32} alt="icon_bank" />
                      <span className="text-muted fs-7 mb-0 me-2">
                        {app.name}
                      </span>
                    </div>
                  </OpenApp>
                </div>
              ))}
          </div> */}
          {this.state.payment === "card" && (
            <div
              className="row px-3 mx-0 px-0 mt-3 position-fixed"
              style={{ bottom: "15px", right: "20px", left: "20px" }}
              id="uploadImage"
            >
              <div className="col-12 px-0">
                <ImageProvider
                  isBtn={true}
                  images={this.state.images}
                  updateImages={(images) =>
                    this.setState({ images: images, pending: true }, () =>
                      this.payInvoice()
                    )
                  }
                />
              </div>
              {/* <div className="col-3 p-1 position-relative">
              <img
                className="w-100 h-100 cover-fill"
                src={this.state.images[0].data_url}
              />
              <RiCloseCircleFill
                onClick={() => onImageRemove(0)}
                className="position-absolute text-muted"
                style={{ top: "7px", right: "7px" }}
                size="20"
              />
            </div> */}
            </div>
          )}
          {(this.state.payment === "gateway" ||
            this.state.payment === "spot") &&
            this.state.price && (
              <FactorDetail2
                price={this.state.price}
                payable_price={this.state.payable_price}
                discount={this.state.discount}
                shipping={this.state.shipping}
              />
            )}
          <div className="row mx-0 px-4">
            {this.state.shop && (
              <div className="col-12 bg-light-gray rounded14 p-3 my-4">
                {this.state.shop.has_terms && (
                  <span>
                    خرید شما به منزله پذیرش{" "}
                    <span
                      className="color-main btn p-0 fw-bolder"
                      onClick={() =>
                        this.setState({ termsModal: true, terms: [] }, () =>
                          this.getTerms(`v1/shops/${this.state.shop_uid}/terms`)
                        )
                      }
                    >
                      قوانین فروشگاه
                    </span>
                    {" است."}
                  </span>
                )}
                {/*<span className="fs-7 fw-bolder">*/}
                {/*  لازم به ذکر است که گیتی مارکت هیچ مسئولیتی در قبال خرید شما*/}
                {/*  نداشته و شما مبلغ را مستقیما برای خود فروشنده واریز خواهید*/}
                {/*  کرد، برای اطلاعات بیشتر{" "}*/}
                {/*  <span*/}
                {/*    className="color-main btn p-0 fs-7 fw-bolder"*/}
                {/*    onClick={() =>*/}
                {/*      this.setState({ termsModal: true, terms: [] }, () =>*/}
                {/*        this.getTerms("v1/terms-of-use/sections/user-buy/items")*/}
                {/*      )*/}
                {/*    }*/}
                {/*  >*/}
                {/*    قوانین و مقررات*/}
                {/*  </span>{" "}*/}
                {/*  {this.state.shop.has_terms && (*/}
                {/*    <span>*/}
                {/*      و یا{" "}*/}
                {/*      <span*/}
                {/*        className="color-main btn p-0 fs-7 fw-bolder"*/}
                {/*        onClick={() =>*/}
                {/*          this.setState({ termsModal: true, terms: [] }, () =>*/}
                {/*            this.getTerms(*/}
                {/*              `v1/shops/${this.state.shop_uid}/terms`*/}
                {/*            )*/}
                {/*          )*/}
                {/*        }*/}
                {/*      >*/}
                {/*        قوانین این فروشگاه*/}
                {/*      </span>{" "}*/}
                {/*    </span>*/}
                {/*  )}*/}
                {/*  را مطالعه فرمایید*/}
                {/*</span>*/}
              </div>
            )}
          </div>
          {this.state.payment === "gateway" && (
            <div
              className="row px-0 mx-0 px-0 mt-3 position-fixed"
              style={{ bottom: "15px", right: "20px", left: "20px" }}
            >
              <button
                disabled={this.state.pending || !this.state.selectedGateway}
                onClick={() => this.payGateway()}
                className="btn fw-bold bg-disabled text-white bg-color-main rounded28 py-2 w-100"
              >
                {this.state.pending ? (
                  <span
                    className="spinner-border spinner-border-sm text-white"
                    role="status"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                ) : (
                  "تایید و پرداخت"
                )}
              </button>
            </div>
          )}
          {this.state.payment === "spot" && (
            <div
              className="row px-0 mx-0 px-0 mt-3 position-fixed"
              style={{ bottom: "15px", right: "20px", left: "20px" }}
            >
              <button
                disabled={this.state.pending}
                className="btn fw-bold text-white bg-color-main rounded28 py-2 w-100"
                onClick={() => this.paySpot()}
              >
                {this.state.pending ? (
                  <span
                    className="spinner-border spinner-border-sm text-white"
                    role="status"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                ) : (
                  "تایید و ثبت سفارش"
                )}
              </button>
            </div>
          )}
        </body>
        {/* {this.state.payable_price && (
          <Footer
            type={"invoic"}
            path={"factor"}
            shopUid={this.state.shop_uid}
            invoiceUid={this.state.invoiceUid}
            payable_price={this.state.payable_price}
            btnText={"پرداخت"}
            isDisabled={false}
            images={this.state.images}
          />
        )} */}
        {this.state.factorDetail && (
          <FactorDetail
            price={this.state.price}
            payable_price={this.state.payable_price}
            discount={this.state.discount}
            shipping={this.state.shipping}
            factorDetail={this.state.factorDetail}
            changeModal={(e) => this.setState({ factorDetail: e })}
          />
        )}
        {this.state.cardDetail && (
          <CardNumberDetail
            card={this.state.card}
            cardDetail={this.state.cardDetail}
            changeModal={(e) => this.setState({ cardDetail: e })}
          />
        )}
        {this.state.termsModal && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
            isOpen={this.state.termsModal}
            toggle={() => this.setState({ termsModal: false })}
          >
            <ModalBody className="row mx-0 p-4 position-relative">
              <div style={{ marginBottom: "90px" }}>
                {this.state.terms.map((term, t) => (
                  <div className="col-12 px-0 fw-bold">
                    <h4 className="fs-5 fw-bold">{term.title}</h4>
                    <p
                      className="text-muted"
                      style={{ whiteSpace: "break-spaces" }}
                    >
                      {term.des}
                    </p>
                  </div>
                ))}
              </div>
              <button
                onClick={() => this.setState({ termsModal: false })}
                className="btn rounded28 py-2 w-100 fw-bold bg-color-main text-center text-white"
              >
                متوجه شدم
              </button>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

export default Factor;
